import { DefaultButton, Dropdown, IDropdownOption, IPanelStyles, Panel, PanelType, PrimaryButton } from "@fluentui/react";
import React from "react";
import { DataUtils } from "../../../common/views/DataUtils";
import { defaultButtonStyles, dropdownStyles, primaryButtonStyles } from "../../../common/views/DefaultStyles";
import FilterButton from "../../../common/views/FilterButton";
import { Utils } from "../../../common/views/Utils";
import { SortModel } from "../../../home/models/PageTypes";
import { MenuModel } from "../../models/CategoryModel";
import { UserProductFilterModel } from "../../models/ProductModel";
import { ProductUtils } from "../../ProductUtils";
import CategoryMenuItemView from "../shared/CategoryMenuItemView";

export const panelStyles: Partial<IPanelStyles> = {
    header: {
        position: 'absolute', // Make the header absolute
        top: 0,
        left: 0,
        width: '100%', // Ensure it stretches to the full width
        backgroundColor: 'white', // Optional: Set a background to cover content
        zIndex: 1, // Ensure it's on top of other elements
        padding: '16px 24px', // Add padding to match default styles
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', // Optional shadow for separation
    },
    content: {
        marginTop: '64px', // Push content down to account for the header height
    },
};

export type ProductFilterProps = {
    filter: UserProductFilterModel;
    onValueChange: (field: keyof UserProductFilterModel, value: any) => void;
    categoryList: MenuModel[];
    getSelectedCategoryList: () => MenuModel[];
    onCategoryChecked: (category: MenuModel, checked: boolean) => void;
    onCategoryCollapsed: (category: MenuModel, collapsed: boolean) => void;
    sizeOptions: IDropdownOption[];
    onCancel: () => void;
    onFilter: () => void;
}

export default function ProductFilterView({
    filter, onValueChange, categoryList, getSelectedCategoryList, onCategoryChecked,
    onCategoryCollapsed, sizeOptions, onFilter, onCancel
}: ProductFilterProps) {
    const sortOptions: SortModel[] = ProductUtils.getSortOptions();

    const width6 = Utils.getColumnWidth(6);
    const width12 = Utils.getColumnWidth(12);

    const onSortChange = (event: React.FormEvent<HTMLDivElement>, item: any) => {
        let model = new SortModel();
        model.key = item.key;
        model.name = item.name;
        model.text = item.text;
        model.direction = item.direction;

        onValueChange("sortModel", model);
    }

    const sortPicker = () => {
        return <>
            <Dropdown
                label="Sort By"
                selectedKey={filter.sortModel.key}
                onChange={onSortChange}
                options={sortOptions}
                styles={dropdownStyles}
            />
        </>;
    }

    const header = () => {
        return <div className="panel-header ms-Grid">
            <div className="ms-Grid-row ph-10">
                <div className={width6}>
                    <DefaultButton
                        style={{ width: "100%" }}
                        onClick={onCancel}
                        styles={defaultButtonStyles}
                    >Cancel</DefaultButton>
                </div>
                <div className={width6}>
                    <PrimaryButton
                        onClick={onFilter}
                        styles={primaryButtonStyles}
                        style={{ width: "100%" }}
                    >Apply</PrimaryButton>
                </div>
            </div>
        </div>
    }

    return <div>
        <Panel
            isBlocking={true}
            isOpen={true}
            isLightDismiss={false}
            type={PanelType.custom}
            customWidth={DataUtils.PANEL_WIDTH}
            onRenderHeader={header}
            hasCloseButton={false}
            styles={{
                header: panelStyles.header,
                content: { paddingLeft: "10px !important", paddingRight: "10px !important" }
            }}
        >
            <div className="ms-Grid pv-10">
                <div className="ms-Grid-row">
                    <div className={width12}>
                        {sortPicker()}
                    </div>
                </div>

                <div className="pt-20">
                    {getSelectedCategoryList().map((item: MenuModel, index: number) => {
                        return <>
                            <FilterButton
                                text={item.text}
                                onDelete={() => onCategoryChecked(item, false)}
                            />
                        </>;
                    })}
                </div>

                <div className="pt-15">
                    {categoryList.map((item: MenuModel, index: number) => {
                        return <>
                            <CategoryMenuItemView
                                item={item}
                                hideZeroCount={true}
                                onChecked={onCategoryChecked}
                                onCollapsed={onCategoryCollapsed}
                            />
                        </>
                    })}
                </div>
            </div>
        </Panel>
    </div>;
}